import { useEffect, useState } from "react";
import { useUserStore } from "../../stores";
import { useNavigate } from "react-router";
import { DEBUG, UserApi } from "../../api";

const useAuth = (authenticated: boolean): boolean => {
  const { sentAuthReq, setUser, setAuthReq, user } = useUserStore();
  const [loading, setLoading] = useState<boolean>(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (DEBUG) return setLoading(false);
    if (sentAuthReq) {
      if (!authenticated && user) navigate("/");
      if (authenticated && !user) navigate("/login");
      return setLoading(false);
    }
    UserApi.getMe()
      .then((user) => {
        setUser(user);
        if (!authenticated) navigate("/");
      })
      .catch(() => {
        if (authenticated) navigate("/login");
      })
      .finally(() => {
        setLoading(false);
        setAuthReq(true);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated, navigate, sentAuthReq]);

  return loading;
};

export default useAuth;
